module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/costume_02@3x-22655408531090fe7c71bd70251742ed.webp";